import { render } from "./box-circle.svg?vue&type=template&id=aecb90ce?inline"
const script = {}
script.render = render

export default script